<script setup lang="ts">
import type { OrganizationJs } from "@/generated/models";
import SimpleButton from "ls/components/simple-button/SimpleButton.vue";
import { SimpleDialogContent, SimpleDialogDescription, SimpleDialogFooter, SimpleDialogHeader, SimpleDialogTitle } from "ls/components/simple-dialog";
import { useAccessLevelFromOrganization } from "ls/features/organizations/useOrganizationAccessLevel";
import { toOrganizationMembers } from "ls/router/builders";
import { DialogClose } from "reka-ui";

const props = defineProps<{
  organization: OrganizationJs;
}>();

const { isAdmin } = useAccessLevelFromOrganization(() => props.organization);
</script>

<template>
  <SimpleDialogContent>
    <SimpleDialogHeader>
      <SimpleDialogTitle>
        Change your Cloud role to author
      </SimpleDialogTitle>
      <SimpleDialogDescription>
        <template v-if="isAdmin">
          To create and edit documents and whiteboards, change your Cloud role to author on the members page.
        </template>
        <template v-else>
          To create and edit documents and whiteboards, ask an admin to change your Cloud role to author on the members page.
        </template>
      </SimpleDialogDescription>
    </SimpleDialogHeader>
    <SimpleDialogFooter>
      <DialogClose as-child>
        <SimpleButton
          v-if="isAdmin"
          :href="toOrganizationMembers(props.organization)"
          size="large"
        >
          Go to members page
        </SimpleButton>
        <SimpleButton
          v-else
          size="large"
        >
          Got it
        </SimpleButton>
      </DialogClose>
    </SimpleDialogFooter>
  </SimpleDialogContent>
</template>
